export default __webpack_public_path__ + "static/media/860.cc721e72.gif";